// tslint:disable
import * as classNames from "classnames";
import * as React from "react";

import "react-google-maps";

import { HTMLDivProps } from "@blueprintjs/core";

import {
  Alignment,
  Classes as mpdClasses,
  MPDButton,
  States
} from "src/mpd-library";

export interface IDrawControlsProps extends HTMLDivProps {
  align?: Alignment;
  hideDrawControls?: boolean;
  onControlClick(
    event: any,
    type: google.maps.drawing.OverlayType | null
  ): void;
  controlsActive?: boolean;
  defaultMode?: google.maps.drawing.OverlayType | null;
  drawingMode: google.maps.drawing.OverlayType | null;
}

import "./styles.css";

export const DrawControls: React.SFC<IDrawControlsProps> = props => {
  const {
    className,
    align,
    controlsActive,
    hideDrawControls,
    drawingMode,
    onControlClick
  } = props;
  const classes = classNames(
    "geo-map-controls-container",
    mpdClasses.alignmentClass(align || Alignment.LEFT),
    controlsActive && mpdClasses.ACTIVE,
    className
  );

  if (hideDrawControls) {
    return null;
  }

  return (
    <div className={classes}>
      <MPDButton
        name="ui-touch"
        selectName="ui-touch-active"
        className={classNames(
          "move",
          drawingMode === null && mpdClasses.ACTIVE
        )}
        itemState={(drawingMode === null && States.selected) || States.default}
        onClick={e => onControlClick(e, null)}
      />
      <MPDButton
        className={classNames(
          "circle",
          drawingMode === google.maps.drawing.OverlayType.CIRCLE &&
            mpdClasses.ACTIVE
        )}
        itemState={
          (drawingMode === google.maps.drawing.OverlayType.CIRCLE &&
            States.selected) ||
          States.default
        }
        selectName="lay-path-circle-active"
        name="lay-path-circle"
        onClick={e => onControlClick(e, google.maps.drawing.OverlayType.CIRCLE)}
      />
      <MPDButton
        className={classNames(
          "rectangle",
          drawingMode === google.maps.drawing.OverlayType.RECTANGLE &&
            mpdClasses.ACTIVE
        )}
        itemState={
          (drawingMode === google.maps.drawing.OverlayType.RECTANGLE &&
            States.selected) ||
          States.default
        }
        selectName="rectangle-active"
        name="rectangle"
        onClick={e =>
          onControlClick(e, google.maps.drawing.OverlayType.RECTANGLE)}
      />
      <MPDButton
        className={classNames(
          "polygon",
          drawingMode === google.maps.drawing.OverlayType.POLYGON &&
            mpdClasses.ACTIVE
        )}
        itemState={
          (drawingMode === google.maps.drawing.OverlayType.POLYGON &&
            States.selected) ||
          States.default
        }
        selectName="polygon-active"
        name="polygon"
        onClick={e =>
          onControlClick(e, google.maps.drawing.OverlayType.POLYGON)}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/draw-controls.tsx